module.exports = __webpack_public_path__ + "static/media/PDF_85.91b5bb4d.pdf";